// utils.js
export function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  export function formatDateTime(dateString) {
    const date = new Date(dateString);
    
    // Format date with month in words
    const year = date.getFullYear();
    const month = date.toLocaleString('default', { month: 'long' }); // Get month as a full word
    const day = String(date.getDate()).padStart(2, '0');
    
    // Format time in 12-hour format with AM/PM
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const amPm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert to 12-hour format and handle midnight (0 => 12)
    
    return `${month} ${day}, ${year} ${hours}:${minutes} ${amPm}`;
}